import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LogoMark } from "./Logo";

const KEY = "bpv_18_plus_confirmed";

export const AgeGate = () => {
  const [open, setOpen] = useState(() => localStorage.getItem(KEY) !== "1");

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  const accept = () => {
    localStorage.setItem(KEY, "1");
    setOpen(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center overflow-y-auto bg-black/90 p-4 backdrop-blur-2xl" data-testid="age-gate-modal">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,rgba(225,29,72,0.22),transparent_60%)]" />
      <motion.div
        initial={{ opacity: 0, y: 24, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative w-full max-w-xl border border-rose-900/40 bg-[#0d0c11] p-8 sm:p-12"
      >
        <div className="mb-8 flex items-center gap-4">
          <LogoMark size={44} />
          <span className="font-mono-d border border-rose-600 px-3 py-1 text-xs tracking-[0.3em] text-rose-400">18+</span>
        </div>
        <p className="eyebrow mb-4">Aviso de conteúdo adulto</p>
        <h1 className="font-serif-d mb-6 text-3xl font-semibold leading-tight text-white sm:text-4xl">
          Este site contém <span className="italic text-rose-500">material sexualmente explícito.</span>
        </h1>
        <div className="space-y-3 text-sm leading-relaxed text-slate-300 sm:text-base">
          <p>Ao entrar, você declara que tem <strong className="text-white">18 anos ou mais</strong> (ou a maioridade legal em sua jurisdição) e que o acesso a conteúdo adulto é permitido onde você está.</p>
          <p>Você concorda em não permitir o acesso de menores de idade e aceita os nossos Termos de Uso.</p>
        </div>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <button onClick={accept} data-testid="age-gate-accept-button" className="group relative flex-1 overflow-hidden bg-rose-600 px-6 py-4 text-sm font-semibold uppercase tracking-[0.18em] text-white transition-colors hover:bg-rose-500">
            Tenho 18 anos ou mais — Entrar
          </button>
          <a href="https://www.google.com" data-testid="age-gate-exit-button" className="flex-1 border border-slate-700 px-6 py-4 text-center text-sm uppercase tracking-[0.18em] text-slate-300 transition-colors hover:border-slate-400 hover:text-white">
            Sair
          </a>
        </div>
        <p className="mt-6 text-xs text-slate-400">Pais: utilizem ferramentas de controle parental para bloquear este site.</p>
      </motion.div>
    </div>
  );
};
